import { createSelector } from "@reduxjs/toolkit";

import { contentLanguagesSelector, primaryContentLanguageCodeSelector } from "@skilitics/nautilus-core-designer-data";

import type { NautilusDesignerAppState } from "../shared.ts";

export const appConfigSelector = (state: NautilusDesignerAppState) => state.appConfig;

export const getManifestSelector = createSelector(appConfigSelector, (appConfig) => appConfig.getManifest);

/** whether a node designer says an author can select it in its own right */
export const getIsSelectionTargetSelector = createSelector(
  getManifestSelector,
  (getManifest) => (typeId: string) => !!getManifest(typeId, { ignoreIfNotFound: true })?.designer.selectionTarget,
);

export const getPlaceholderManifestSelector = createSelector(
  appConfigSelector,
  (appConfig) => appConfig.getPlaceholderManifest,
);

export const getValueSubtypeDefinitionSelector = createSelector(
  appConfigSelector,
  (appConfig) => appConfig.getValueSubtypeDefinition,
);

export const rootNodeParentContextSelector = createSelector(
  appConfigSelector,
  (appConfig) => appConfig.rootNodeParentContext,
);

const activeContentLanguageCodeRawSelector = createSelector(appConfigSelector, (appConfig) => appConfig.activeLang);

export const activeContentLanguageCodeSelector = createSelector(
  activeContentLanguageCodeRawSelector,
  contentLanguagesSelector,
  primaryContentLanguageCodeSelector,
  (activeLang, contentLanguages, primaryLang): string => {
    // TODO: hot reload will recreate the store and briefly have no active language
    // to avoid this means taking store out of react flakey control (currently useMemo)
    // but at top level is tricky too due to deps like getManifest, api having to move there too
    // assert(activeLang, "Active language must be defined");
    if (!contentLanguages.find((cl) => cl.code === activeLang)) {
      console.warn(
        `Active language ${activeLang} not found in content languages, reverting to primary language ${primaryLang}.`,
      );
      return primaryLang;
    }
    return activeLang;
  },
);
